// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-treeview-item {
  --list-indent-size: 28px;
}
:where(.vuetify-styles) .v-treeview-item.v-treeview-item--filtered {
  display: none;
}
:where(.vuetify-styles) .v-treeview-item.v-list-item--disabled:not(a) {
  pointer-events: auto;
}
:where(.vuetify-styles) .v-treeview-item.v-list-item--disabled:not(a) .v-selection-control {
  pointer-events: none;
}
:where(.vuetify-styles) .v-treeview-item__level {
  width: 28px;
}
:where(.vuetify-styles) .v-treeview--fluid .v-treeview-item__level {
  width: 0;
}

:where(.vuetify-styles) .v-treeview {
  --v-treeview-indent-line-color: rgb(var(--v-theme-on-surface));
  --v-treeview-indent-line-opacity: 0.4;
}
:where(.vuetify-styles) .v-treeview.v-list {
  --indent-padding: 16px;
}
:where(.vuetify-styles) .v-treeview.v-list--disabled .v-list-item__prepend {
  pointer-events: auto;
}
:where(.vuetify-styles) .v-treeview .v-list-item--slim > .v-list-item__prepend > .v-icon ~ .v-list-item__spacer {
  width: var(--v-list-prepend-gap, 10px);
}
:where(.vuetify-styles) .v-treeview .v-list-item--slim > .v-list-item__prepend:not(:has(.v-list-item-action)) > .v-icon {
  margin-inline-start: -6px;
}
:where(.vuetify-styles) .v-treeview:has(.v-treeview-indent-lines) .v-list-item-action:first-child > .v-selection-control,
:where(.vuetify-styles) .v-treeview:has(.v-treeview-indent-lines) .v-treeview-indent-lines + .v-list-item-action > .v-selection-control {
  margin-inline: min(0px, -1 * (var(--v-selection-control-size) - 28px) / 2);
}

:where(.vuetify-styles) .v-treeview-indent-lines {
  position: absolute;
  inset-inline-start: 0;
  height: 100%;
  display: grid;
  padding-inline-start: 8px;
  padding-block: 0;
  grid-template-columns: repeat(var(--v-indent-parts, 1), var(--prepend-width));
  opacity: var(--v-treeview-indent-line-opacity);
  pointer-events: none;
}

:where(.vuetify-styles) .v-treeview-indent-line, :where(.vuetify-styles) .v-treeview-indent-line::before {
  border: 0px solid var(--v-treeview-indent-line-color);
}
:where(.vuetify-styles) .v-treeview-indent-line--leaf, :where(.vuetify-styles) .v-treeview-indent-line--line {
  border-inline-start-width: 1px;
  height: 100%;
  width: calc(50% + 1px);
  justify-self: end;
}
:where(.vuetify-styles) .v-treeview-indent-line--leaf {
  position: relative;
}
:where(.vuetify-styles) .v-treeview-indent-line--leaf::before {
  content: "";
  position: absolute;
  border-bottom-width: 1px;
  height: calc(50% + 1px);
  width: 100%;
}
:where(.vuetify-styles) .v-treeview-indent-line--leaf:last-child::before {
  width: calc(100% - 4px);
}
:where(.vuetify-styles) .v-treeview-indent-line--leaf-link {
  border-bottom-width: 1px;
  height: calc(50% + 1px);
  margin-inline-start: 0;
  margin-inline-end: 6px;
}
:where(.vuetify-styles) .v-treeview-indent-line--last-leaf {
  border-inline-start-width: 1px;
  border-bottom-width: 1px;
  height: calc(50% + 1px);
  margin-inline-start: calc(50% - 1px);
  border-bottom-left-radius: 4px;
}
:where(.vuetify-styles) .v-locale--is-rtl.v-treeview-indent-line--last-leaf, :where(.vuetify-styles) .v-locale--is-rtl .v-treeview-indent-line--last-leaf {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 4px;
}

:where(.vuetify-styles) .v-treeview-indent-line--last-leaf:last-child {
  margin-inline-end: 4px;
}

:where(.vuetify-styles) .v-treeview-group.v-list-group {
  --list-indent-size: 0px;
}
:where(.vuetify-styles) .v-treeview-group.v-list-group > .v-treeview-item__level {
  width: 0px;
}
:where(.vuetify-styles) .v-treeview-group.v-list-group .v-list-group__items .v-list-item {
  padding-inline-start: calc(var(--indent-padding)) !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VTreeview/VTreeviewItem.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,QAAQ;AACV;;AAEA;EACE,8DAA8D;EAC9D,qCAAqC;AACvC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,6EAA6E;EAC7E,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;AACvD;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,uBAAuB;EACvB,oCAAoC;EACpC,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,4DAA4D;AAC9D","sourcesContent":[".v-treeview-item {\n  --list-indent-size: 28px;\n}\n.v-treeview-item.v-treeview-item--filtered {\n  display: none;\n}\n.v-treeview-item.v-list-item--disabled:not(a) {\n  pointer-events: auto;\n}\n.v-treeview-item.v-list-item--disabled:not(a) .v-selection-control {\n  pointer-events: none;\n}\n.v-treeview-item__level {\n  width: 28px;\n}\n.v-treeview--fluid .v-treeview-item__level {\n  width: 0;\n}\n\n.v-treeview {\n  --v-treeview-indent-line-color: rgb(var(--v-theme-on-surface));\n  --v-treeview-indent-line-opacity: 0.4;\n}\n.v-treeview.v-list {\n  --indent-padding: 16px;\n}\n.v-treeview.v-list--disabled .v-list-item__prepend {\n  pointer-events: auto;\n}\n.v-treeview .v-list-item--slim > .v-list-item__prepend > .v-icon ~ .v-list-item__spacer {\n  width: var(--v-list-prepend-gap, 10px);\n}\n.v-treeview .v-list-item--slim > .v-list-item__prepend:not(:has(.v-list-item-action)) > .v-icon {\n  margin-inline-start: -6px;\n}\n.v-treeview:has(.v-treeview-indent-lines) .v-list-item-action:first-child > .v-selection-control,\n.v-treeview:has(.v-treeview-indent-lines) .v-treeview-indent-lines + .v-list-item-action > .v-selection-control {\n  margin-inline: min(0px, -1 * (var(--v-selection-control-size) - 28px) / 2);\n}\n\n.v-treeview-indent-lines {\n  position: absolute;\n  inset-inline-start: 0;\n  height: 100%;\n  display: grid;\n  padding-inline-start: 8px;\n  padding-block: 0;\n  grid-template-columns: repeat(var(--v-indent-parts, 1), var(--prepend-width));\n  opacity: var(--v-treeview-indent-line-opacity);\n  pointer-events: none;\n}\n\n.v-treeview-indent-line, .v-treeview-indent-line::before {\n  border: 0px solid var(--v-treeview-indent-line-color);\n}\n.v-treeview-indent-line--leaf, .v-treeview-indent-line--line {\n  border-inline-start-width: 1px;\n  height: 100%;\n  width: calc(50% + 1px);\n  justify-self: end;\n}\n.v-treeview-indent-line--leaf {\n  position: relative;\n}\n.v-treeview-indent-line--leaf::before {\n  content: \"\";\n  position: absolute;\n  border-bottom-width: 1px;\n  height: calc(50% + 1px);\n  width: 100%;\n}\n.v-treeview-indent-line--leaf:last-child::before {\n  width: calc(100% - 4px);\n}\n.v-treeview-indent-line--leaf-link {\n  border-bottom-width: 1px;\n  height: calc(50% + 1px);\n  margin-inline-start: 0;\n  margin-inline-end: 6px;\n}\n.v-treeview-indent-line--last-leaf {\n  border-inline-start-width: 1px;\n  border-bottom-width: 1px;\n  height: calc(50% + 1px);\n  margin-inline-start: calc(50% - 1px);\n  border-bottom-left-radius: 4px;\n}\n.v-locale--is-rtl.v-treeview-indent-line--last-leaf, .v-locale--is-rtl .v-treeview-indent-line--last-leaf {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 4px;\n}\n\n.v-treeview-indent-line--last-leaf:last-child {\n  margin-inline-end: 4px;\n}\n\n.v-treeview-group.v-list-group {\n  --list-indent-size: 0px;\n}\n.v-treeview-group.v-list-group > .v-treeview-item__level {\n  width: 0px;\n}\n.v-treeview-group.v-list-group .v-list-group__items .v-list-item {\n  padding-inline-start: calc(var(--indent-padding)) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
